import React, { memo } from 'react'

import Logo from 'assets/images/logo.png'

import AppHeaderControl from './AppHeaderControl'

import {
  AppHeader,
  AppHeaderContainer,
  AppHeaderContent,
  AppHeaderLogo,
  AppHeaderNav,
  AppHeaderMenu,
  AppHeaderMenuItem,
  AppHeaderMenuLink,
  AppHeaderActions,
} from './styled'
import AppHeaderAuth from './AppHeaderAuth'
import { useAppState } from 'store'
import { useHistory } from 'react-router-dom';
import { pages } from 'pages/pages'

interface AppHeaderProps {
  isStiky: boolean
}

export default memo(({ isStiky }: AppHeaderProps) => {
  const { user } = useAppState(state => state.auth)
  const { push } = useHistory()

  return (
    <AppHeader isStiky={isStiky}>
      <AppHeaderContainer>
        <AppHeaderContent>
          <AppHeaderLogo src={Logo} alt="Acespace Courts" onClick={() => push(pages.Home.path)}/>
          <AppHeaderNav>
            <AppHeaderMenu>
              <AppHeaderMenuItem>
                <AppHeaderMenuLink to="/how-it-works">
                  How it works
                </AppHeaderMenuLink>
              </AppHeaderMenuItem>
              <AppHeaderMenuItem>
                <AppHeaderMenuLink to="/pricing">Pricing</AppHeaderMenuLink>
              </AppHeaderMenuItem>
              <AppHeaderMenuItem>
                <AppHeaderMenuLink to="/about">About</AppHeaderMenuLink>
              </AppHeaderMenuItem>
              <AppHeaderMenuItem>
                <AppHeaderMenuLink to="/news">News</AppHeaderMenuLink>
              </AppHeaderMenuItem>
            </AppHeaderMenu>
          </AppHeaderNav>
          <AppHeaderActions>
            {user ? <AppHeaderControl /> : <AppHeaderAuth />}
          </AppHeaderActions>
        </AppHeaderContent>
      </AppHeaderContainer>
    </AppHeader>
  )
})
